module.exports = {
  email: 'chongtszwing@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/alphrc',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/rainchong',
    },
    {
      name: 'Rednote',
      url: 'https://www.rednote.com/user/profile/646500860000000029017017',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/tszzrain',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/tszzrain',
    },
    {
      name: 'Threads',
      url: 'https://www.threads.net/tszzrain',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    // Order here is document order on the home page, not preference: the
    // active-section hook walks this list and takes the last section whose top
    // has passed under the header, so a link out of sequence would light the
    // wrong one.
    {
      name: 'Research',
      url: '/#research',
    },
    {
      name: 'Blogs',
      url: '/#blogs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  // Consumed by gatsby-config.js for the PWA manifest and image placeholders.
  // Keep in sync with src/styles/variables.js.
  colors: {
    accent: '#64ffda',
    bg: '#0a0a0b',
    bgDeep: '#08080a',
  },
};
